<template>
  <v-card>
    <v-card-title class='title fontcolor'>{{pageTitle}}</v-card-title>
    <template>
      <v-form ref='form' v-model='valid' lazy-validation>
        <v-row>
          <v-col class='d-flex ml-4 pb-0' cols='6'>
            <v-select
              class='caption'
              @change='onChangeEntity'
              :items='LOCATION_ENTITY_LIST'
              item-text='name'
              label='Select Entity*'
              v-model='entityName'
              dense
              hint='Please select the required entity for importing data.'
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols='6' class='ml-4 pt-0'>
            <v-card-text class='pt-0 pb-0' v-if='importFileVisible'>{{entityText}}</v-card-text>
          </v-col>
        </v-row>
        <v-row v-if="getSampleDownloadFile" >
          <v-col cols='6' class='ml-0 pt-0'>
            <AdminSampleDownloadButton :fileName='getSampleDownloadFile' :entityName='getSampleDownloadText' />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols='6' class='ml-4'>
            <v-file-input
              accept='.csv'
              @change='importCsvFile'
              label='Upload CSV File*'
              persistent-hint
              v-model='chosenFile'
              :rules='[IsValidCSV]'
              :disabled='!importFileVisible'
              hint='Allowed file format: .csv. File size should not be more than 10MB.'
            ></v-file-input>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row>
            <small color='primary' class='ma-4 pl-2'>*indicates required fields</small>
            <v-spacer></v-spacer>
            <span v-if='readyForDownload' class='mr-4'>
              <v-btn
                v-if='logFileLink'
                target='_blank'
                :href='logFileLink'
                outlined
                class='fontcolor'
              >
                <v-icon dark>mdi-download</v-icon>View Log
              </v-btn>
            </span>
            <v-btn
              :loading='btnLoader'
              outlined
              class='mb-2 mr-4 pa-2 fontcolor'
              :disabled='onSelectCSV'
              @click='onUpload'
            >
              <v-icon dark>mdi-upload</v-icon>Upload
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-form>
    </template>
  </v-card>
</template>

<script>
import CONSTANTS from './../../../../config/constant'
import ENV_CONSTANTS from './../../../../config/envVariables'
import AdminSampleDownloadButton from './../../sampledownloads/sampledownloadbutton'
export default {
  name: 'LocationEntityImport',
  data: () => ({
    sampleDownloadFile: '',
    sampleDownloadText: '',
    pageTitle: 'Import Location Data',
    LOCATION_ENTITY_LIST: CONSTANTS.LOCATION_ENTITY_LIST,
    importFileVisible: false,
    entityText: '',
    btnLoader: false,
    valid: true,
    entityName: '',
    onSelectCSV: true,
    chosenFile: undefined,
    id: undefined,
    logFileLink: '',
    readyForDownload: false,
    downloadLoader: false
  }),
  components: {
    'AdminSampleDownloadButton': AdminSampleDownloadButton
  },
  computed: {
    userId () {
      return this.$store.getters['AuthModule/getUserId']
    },
    getSampleDownloadFile () {
      return this.sampleDownloadFile
    },
    getSampleDownloadText () {
      return this.sampleDownloadText
    }
  },
  methods: {
    onChangeEntity (entityId) {
      this.chosenFile = undefined
      this.id = entityId.toLowerCase().replace(/\s+/g, '')
      this.importFileVisible = true
      switch (entityId) {
        case 'Country':
          this.entityText = CONSTANTS.COUNTRY_ENTITY_TEXT
          this.sampleDownloadFile = CONSTANTS.SAMPLE_DOWNLOAD.ILD_PAGE.COUNTRY_DOWNLOAD_FILE
          this.sampleDownloadText = CONSTANTS.SAMPLE_DOWNLOAD.ILD_PAGE.COUNTRY_DOWNLOAD_TEXT
          break
        case 'State':
          this.entityText = CONSTANTS.STATE_ENTITY_TEXT
          this.sampleDownloadFile = CONSTANTS.SAMPLE_DOWNLOAD.ILD_PAGE.STATE_DOWNLOAD_FILE
          this.sampleDownloadText = CONSTANTS.SAMPLE_DOWNLOAD.ILD_PAGE.STATE_DOWNLOAD_TEXT
          break
        case 'County':
          this.entityText = CONSTANTS.COUNTY_ENTITY_TEXT
          this.sampleDownloadFile = CONSTANTS.SAMPLE_DOWNLOAD.ILD_PAGE.COUNTY_DOWNLOAD_FILE
          this.sampleDownloadText = CONSTANTS.SAMPLE_DOWNLOAD.ILD_PAGE.COUNTY_DOWNLOAD_TEXT
          break
        case 'Jurisdiction':
          this.entityText = CONSTANTS.JURISDICTION_ENTITY_TEXT
          this.sampleDownloadFile = CONSTANTS.SAMPLE_DOWNLOAD.ILD_PAGE.JURISDICTION_DOWNLOAD_FILE
          this.sampleDownloadText = CONSTANTS.SAMPLE_DOWNLOAD.ILD_PAGE.JURISDICTION_DOWNLOAD_TEXT
          break
        case 'Postal Code':
          this.entityText = CONSTANTS.POSTALCODE__ENTITY_TEXT
          this.sampleDownloadFile = CONSTANTS.SAMPLE_DOWNLOAD.ILD_PAGE.POSTALCODE_DOWNLOAD_FILE
          this.sampleDownloadText = CONSTANTS.SAMPLE_DOWNLOAD.ILD_PAGE.POSTALCODE_DOWNLOAD_TEXT
          break
        case 'Township':
          this.entityText = CONSTANTS.TOWNSHIP_ENTITY_TEXT
          this.sampleDownloadFile = CONSTANTS.SAMPLE_DOWNLOAD.ILD_PAGE.TOWNSHIP_DOWNLOAD_FILE
          this.sampleDownloadText = CONSTANTS.SAMPLE_DOWNLOAD.ILD_PAGE.TOWNSHIP_DOWNLOAD_TEXT
          break
        case 'Useful Links':
          this.entityText = CONSTANTS.USEFULLINKS_ENTITY_TEXT
          this.sampleDownloadFile = CONSTANTS.SAMPLE_DOWNLOAD.ILD_PAGE.USEFULLINKS_DOWNLOAD_FILE
          this.sampleDownloadText = CONSTANTS.SAMPLE_DOWNLOAD.ILD_PAGE.USEFULLINKS_DOWNLOAD_TEXT
          break
        default:
          this.entityText = ''
          break
      }
    },
    IsValidCSV (v) {
      if (v) {
        const val = v.name
        if (
          val &&
          val !== undefined &&
          val !== null &&
          val.slice(val.lastIndexOf('.') + 1) !== 'csv' &&
          val.slice(val.lastIndexOf('.') + 1) !== 'CSV'
        ) {
          return 'Invalid file format. Only .csv file is allowed.'
        } else if (v.size / 1024 > ENV_CONSTANTS.MAXCSVFILESIZE) {
          // v.size returns file size in bytes
          this.onSelectCSV = true
          return 'File size should not be more than 10MB.'
        } else {
          return true
        }
      } else {
        return true
      }
    },
    importCsvFile (e) {
      // reset viewlog button upon selecting new file for upload
      this.readyForDownload = false
      this.logFileLink = ''
      this.onSelectCSV = false
      if (!this.chosenFile) {
        this.chosenFile = undefined
      }
      this.chosenFile = e
      return this.chosenFile
    },
    onUpload () {
      if (
        this.$refs.form.validate() &&
        typeof this.chosenFile !== 'undefined'
      ) {
        this.logFileLink = ''
        this.btnLoader = true
        let formData = new FormData()
        formData.append('importedFile', this.chosenFile)
        formData.append('type', this.id)
        formData.append('userId', this.userId)
        new Promise((resolve, reject) => {
          this.$store.dispatch('LocationEntityImportModule/addEntityData', {
            resolve,
            reject,
            formData
          })
        })
          .then(responseData => {
            this.chosenFile = undefined
            this.entityName = ''
            this.importFileVisible = false
            this.btnLoader = false
            this.onSelectCSV = true
            this.readyForDownload = true
            this.logFileLink = responseData.downloadUrl
            this.sampleDownloadFile = ''
            this.$globalStates.notification.type = 'green'
            this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(
              responseData.responseMessage
            )
            this.$globalStates.notification.init_notifications = true
          })
          .catch(response => {
            this.chosenFile = undefined
            this.btnLoader = false
            this.readyForDownload = false
            this.logFileLink = ''
            this.sampleDownloadFile = ''
            this.$globalStates.notification.type = 'error'
            this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(
              response.responseMessage
            )
            this.$globalStates.notification.init_notifications = true
          })
      }
    }
  }
}
</script>
